export default function file() {
  $('.wp-block-sage-group .wp-block-file').wrapAll(
    '<div class="wp-block-files" />'
  );

  $('.wp-block-file a:not(.wp-block-file__button)').attr('target', '_blank');

  $('.wp-block-files')
    .filter(function () {
      return $(this).find('.aligncenter').length;
    })
    .addClass('aligncenter');
}
